// Une clases ignorando falsy: cx('rev-btn', variant && 'rev-btn--primary', className)
const cx = (...parts) => parts.filter(Boolean).join(' ');
export default cx;
